const Location = () => {
    return (
        <div>
            <div className="font-poppins text-5xl text-primary-blue font-extralight text-center pt-8 pb-9">
                Location
            </div>
            <div className="flex justify-center">
                <div className="sm:w-[70%]">
                    <img src="/Map.png" alt="map" style={{ width: "100%" }} />
                </div>
            </div>
            <div className="flex justify-center">
                <a
                    className="font-poppins sm:text-2xl text-primary-blue font-extralight text-center mb-12 mt-3 hover:cursor-pointer w-fit underline text-xl"
                    target="_blank"
                    href="https://maps.app.goo.gl/gutLSnmpjhHiDpd29"
                    rel="noreferrer"
                >
                    <div>Click here to get directions</div>
                </a>
            </div>
        </div>
    );
};

export default Location;
